<template>
  <div>
    <!-- 头部 -->
    <x-header />

    <div class="background">

      <section class="container info-section">

        <!-- 用户信息 -->
        <div class="top">
          <x-userinfo :userInfo="userInfo" :productInfo="productInfo" ></x-userinfo>
        </div>

        <el-divider></el-divider>

        <!-- 支付 -->
        <div class="bottom">

          <!-- 信息 -->
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" >
              <div class="payment-title">
                {{ $t('recharge.payment.package')}}:  {{ productInfo.title || '-' }}
              </div>

              <div class="payment-price">
                Tot. {{ productInfo.price }}
              </div>
            </el-col>

            <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16" class="payment">
              <div class="payment-list">
                <div style="text-align: left;">
                  All Method:
                </div>

                <el-radio-group v-model="payType">
                  <div v-for="(method, index) in payTypeList" :key="index" class="payment-option">
                    <label class="radio-label" :class="{ 'selected': payType === method.type }">
                      <img :src="method.mIcon" alt="icon" class="icon" />
                      <span class="payment-text">{{ method.title }}</span>
                      <el-radio v-model="radio" :label="method.type">&nbsp;</el-radio>
                    </label>
                  </div>
                </el-radio-group>
              </div>

              <!-- <div class="payment-title">
                <i class="el-alert__icon el-icon-success"></i>
                <span>{{ payTitle }}</span>
              </div> -->

              <div>
                <el-form :model="validateForm" :rules="rules" ref="validateForm" >
                  <div class="uid-input">
                    <el-form-item prop="validUid">
                      <el-input
                        :placeholder="$t('recharge.index.uid_placeholder')"
                        v-model.number="validateForm.validUid"
                        class="uid-input-control"
                        style="min-width: 80px; width: 60%;"
                        maxlength="10">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-form>
              </div>

              <div>
                <el-button type="warning" :disabled="submitBtnDisable"  @click="submit" >
                  <span class="payment-title">Pay {{ productInfo.price }}</span>
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div>
            <!-- If you have bought a course, you can use the uid to join the Zoom room that corresponds to the course. -->
          </div>
        </div>
      </section>
    </div>

    <!-- 底部 -->
    <x-footer />
  </div>
</template>

<script>
import footer from '@/views/components/footer'
import header from '@/views/components/header'
import { order } from '@/api/payment'
import paymentConfig from '@/util/payment'
import { redirect } from '@/util/order-redirect'
import collect from 'collect.js'
import inArray from 'locutus/php/array/in_array'
import userInfoComponent from '@/views/shop/components/userInfo'

export default {
  name: 'PaymentIndex',
  components: {
    'x-userinfo': userInfoComponent,
    'x-header': header,
    'x-footer': footer
  },
  props: {
    channel: String,
    default: ''
  },
  created () {
  },
  data () {
    return {
      submitBtnDisable: false,
      infoSubmitBtnDisable: false, // pay info 购买按钮
      payUserInfoVisible: false,
      payForm: {
        actionUrl: '',
        params: []
      },
      buyForm: {
        uid: '',
        productId: ''
      },
      validateForm: {
        validUid: ''
      },
      rules: {
        validUid: [
          { required: true, message: this.$t('recharge.index.uid_required_message'), trigger: 'blur' },
          { type: 'integer', message: this.$t('recharge.index.uid_message'), trigger: 'blur' }
        ]
      },
      payUserInfoForm: {
        name: '',
        phone: '',
        email: ''
      },
      userInfo: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      productInfo: {
        diamond: '',
        price: '',
        productId: ''
      },
      payType: 8,
      payTypeList: [],

      isTest: false
    }
  },
  mounted () {
    this.payTypeList = paymentConfig.typeList
    let params = this.$route.params || {}
    this.userInfo = params.userInfo
    this.buyForm = params.buyForm
    this.productInfo = params.productInfo
    this.isTest = params.isTest

    if (!params.buyForm) {
      this.$router.push({ name: 'Home' })
    } else {
      const userAvatar = params.userInfo.avatar || ''
      if (userAvatar.startsWith('http')) {
        params.userInfo.avatar = userAvatar
      } else if (userAvatar) {
        let avatar = 'none.jpg'
        let subfix = '.jpg'
        const avatars = userAvatar.split(':')
        if (userAvatar.startsWith('default')) {
          avatar = avatars[1] + subfix
        } else if (userAvatar.startsWith('special')) {
          subfix = '.png'
          avatar = avatars[1] + subfix
        }
        params.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatar)
      }
    }

    const collection = collect(this.payTypeList)

    this.payTypeList = collection.filter((value, key) => {
      if (value.product && value.product.length > 0) {
        if (!this.isTest && value.isDev) {
          return false
        }

        if (inArray(this.productInfo.productId, value.product)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }).all()

    const defaultPayType = collect(this.payTypeList).first()
    this.payType = defaultPayType.type
  },
  methods: {
    back () {
      this.$router.push({ name: 'Home' })
    },

    payUserInfoDialogClose () {
      this.submitBtnDisable = false
      this.infoSubmitBtnDisable = false
      this.payUserInfoVisible = false
      this.$refs['payUserForm'].resetFields()
    },

    genOrder () {
      this.submitBtnDisable = true
      this.infoSubmitBtnDisable = true

      switch (this.payType) {
        case 3:
        case 4:
          if (this.payUserInfoForm.email === '' || this.payUserInfoForm.name === '' || this.payUserInfoForm.phone === '') {
            this.payUserInfoVisible = true
            this.submitBtnDisable = true
            this.infoSubmitBtnDisable = false
          } else {
            this.$refs['payUserForm'].validate((valid) => {
              if (!valid) {
                this.$notify.error({
                  title: 'valid faild',
                  message: 'valid faild'
                })
                return false
              }
              this.infoSubmitBtnDisable = false
            })
          }

          break
      }

      let params = {
        type: this.payType,
        uid: this.buyForm.uid,
        productId: this.buyForm.productId,
        lang: 'en_us',
        payUserInfo: this.payUserInfoForm,
        payChannel: 'lesson'
      }

      order(params)
        .then(({ data, msg }) => {
          if (data.orderInfo) {
            this.payForm = data.orderInfo
            redirect(this.payType, this.payForm)
          } else {
            this.$message({
              showClose: true,
              message: msg,
              type: 'error'
            })
            this.submitBtnDisable = false
            this.infoSubmitBtnDisable = false
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: 'Purchase Failed',
            type: 'error'
          })
          this.submitBtnDisable = false
          this.infoSubmitBtnDisable = false
        })
    },

    submit () {
      this.$refs['validateForm'].validate(valid => {
        if (valid) {
          if (this.validateForm.validUid !== this.userInfo.uid) {
            this.$message({
              showClose: true,
              message: 'uid not match!',
              type: 'error'
            })
          } else {
            this.genOrder()
          }
        }
      })
    }
  }
}
</script>

<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: #bba04b;
  background: #bba04b;
}
</style>

<style scoped>
.background {
  background-image: url('~@/assets/images/shop/back.jpg');
  background-size: cover;
  background-position: center;
  margin-top: 86px;
  min-height: 80vh;
  padding-top: 20px;
  padding-bottom: 40px;
  margin-bottom: 0;
}

.info-section {
  color: #f6f7fa;
  padding: 10px;
  margin: 10px auto;
  max-width: 680px;
  border-radius: 10px;
  border: 1px solid #70602b;
}

.top {
  padding: 0px;
  max-width: 680px;
  width: 100%;
  margin-bottom: 10px;
  font-family: SourceHanSansCN-Regular;
}

.bottom {
  margin-left: 40px;
}

.payment {
  border-left: 1px solid #494947;
}

.payment-title {
  color: #d9dbdf;
  font-weight: 200;
  font-size: 20px;
}

.payment-price{
  font-weight: 500;
  font-size: 36px;
}

.payment-list {
  max-width: 300px;
  margin: 10px auto;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.payment-list .payment-option {
  margin-bottom: 10px;
}

.radio-label {
  border: 1px solid rgb(45,45,50);
  background-color: rgb(45,45,50);
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 8px;
  cursor: pointer;
}

/* 选中时的样式 */
.radio-label.selected {
  border: 1px solid #bba04b;
  background-color: rgb(50,50,45);
}

/* 隐藏原生 radio 按钮 */
.hidden-radio {
  display: none;
}

/* 图标样式 */
.icon {
  width: 140px;
  height: 43px;
  margin-right: 5px;
}

/* 支付方式文本 */
.payment-text {
  flex-grow: 1;
  font-size: 16px;
  margin-right: 5px;
}

/* 选中的对勾 */
.checkmark {
  color: #007bff;
  font-weight: bold;
}

.confirm-btn {
  background-color: black;
  width: 200px;
  height: 56px;
  left: 0;
  right: 0;
  margin: auto;
  margin-bottom: 1vh;
  text-align: center;
  color: #ffffff;
  font-size: 21px;
  border-radius: 4px;
  border: none;
}

.confirm-btn:hover {
  background-color: #4f4f4f;
}

@media only screen and (max-width: 860px) {
  .info-section {
    max-width: 800px;
  }

  .top {
    max-width: 800px;
  }
}

@media only screen and (max-width: 768px) {
  .background {
    padding: 5px 5px;
  }

  .info-section {
    padding: 5px;
    max-width: 680px;
  }

  .top {
    max-width: 680px;
  }

  .bottom {
    margin-left: 10px;
  }

  .payment {
    margin-top: 10px;
    border-left: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/shop/recharge/payment.vue